// extracted by mini-css-extract-plugin
module.exports = {"branch":"Branch_branch__2LBVo","supCollChunk":"Branch_supCollChunk__2hl1J","retCollChunk":"Branch_retCollChunk__2IQT9"};